export enum ParamTypes {
  NEXT_FN = "NEXT_FN",
  ERR = "ERR",
  REQUEST = "REQUEST",
  PLATFORM_REQUEST = "PLATFORM_REQUEST",
  NODE_REQUEST = "NODE_REQUEST",
  RESPONSE = "RESPONSE",
  PLATFORM_RESPONSE = "PLATFORM_RESPONSE",
  NODE_RESPONSE = "NODE_RESPONSE",
  RESPONSE_DATA = "RESPONSE_DATA",
  ENDPOINT_INFO = "ENDPOINT_INFO",
  $CTX = "$CTX",
  RES = "RES",
  REQ = "REQ",
  BODY = "BODY",
  PATH = "PATH",
  QUERY = "QUERY",
  HEADER = "HEADER",
  COOKIES = "COOKIES",
  LOCALS = "LOCALS",
  SESSION = "SESSION",
  FILES = "FILES"
}
